"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm font-medium text-foreground-dark hover:text-accent transition-colors duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-0 after:bg-accent hover:after:w-full after:transition-all after:duration-300">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  return <footer className="bg-accent-dark py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <MenuProvider menu_id="17" className="mb-6">
          <FooterMenuConsumer />
        </MenuProvider>
        <p className="text-center text-xs text-foreground-dark/80 mt-4">
          © {new Date().getFullYear()} Alphavision. All rights reserved.
        </p>
      </div>
    </footer>;
}